<template>
  <div>
    <div class="container">
      <comp-tab :data="[{ label: '人员管理', value: 0 }, { label: '角色管理', value: 1 }]" v-model="status" />
    </div>

    <div class="container">
      <el-row gutter="8">
        <el-col span="6">
          <el-input placeholder="请输入员工姓名" prefix-icon="el-icon-search" size="small" v-model="params.name"></el-input>
        </el-col>
        <el-col span="4">
          <el-button @click="onSearch" size="small">搜索</el-button>
        </el-col>
        <el-col class="fr-jcfe" offset="10" span="4">
          <el-button @click="addEmployee" size="small" type="primary">添加员工</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="container">
      <el-table :data="list" border style="width: 100%">
        <el-table-column label="员工姓名" prop="name" width="150" />
        <el-table-column label="手机号" prop="mobile" width="200" />
        <el-table-column label="角色/权限" width="450">
          <template slot-scope="scope">
            <div>
              <div class="role-title">{{ scope.row.storerole.name }}</div>
              <div>
                <span :key="item" class="role-item" v-for="item in scope.row.storerole.cansList">{{ item }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="添加时间" width="250">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.createdat * 1000).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <div style="text-align: center;" v-if="!scope.row.isSelf">
              <el-button :disabled="scope.row.name == 'Admin'" @click="onEdit(scope.row)" size="small" type="text">修改</el-button>
              <el-button :disabled="scope.row.name == 'Admin'" @click="onDelete(scope.row)" size="small" type="text">删除</el-button>
            </div>
            <div style="color: #999;text-align: center;" v-else>当前帐号</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../components/tab/index.vue';
import { M } from '../../service/grpc.js';
import { rpc } from '../../service/index.js';
import { getToken } from '../../service/helper.js';

export default {
  name: 'Employee',
  components: { 'comp-tab': Tab },
  watch: {
    status() {
      this.$router.replace('/setting/roles');
    }
  },
  data() {
    return {
      token: '',
      status: 0,
      params: {
        name: '',
        count: 100
      },
      list: []
    };
  },
  mounted() {
    this.token = getToken();
    this.onSearch();
  },
  methods: {
    async onSearch() {
      const res = await rpc(
        'StoreStoreAdminService.GetStoreAdminList',
        M('StoreAdminListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      const storeroleidlist = res.storeadminlistList.map(v => v.storeroleid);
      const res1 = await rpc(
        'StoreStoreRoleService.GetStoreRoleList',
        M('StoreRoleListQueryRequest', {
          token: M('Token', { token: this.token }),
          idlistList: storeroleidlist,
          count: storeroleidlist.length
        })
      );
      res.storeadminlistList.forEach(item => (item.storerole = res1.storerolelistList.find(v => v.id === item.storeroleid)));
      this.list = res.storeadminlistList;
    },
    onEdit({ id }) {
      this.$router.push({ name: 'setting-employee-edit', query: { id: id } });
    },
    onDelete(row) {
      this.$confirm('确认删除？')
        .then(async () => {
          rpc(
            'StoreStoreAdminService.DeleteStoreAdmin',
            M('IDWithTokenRequest', {
              token: M('Token', { token: this.token }),
              id: row.id
            })
          ).then(res => {
            this.list.splice(this.list.findIndex(v => v.id === row.id), 1);
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          });
        })
        .catch(() => {});
    },
    addEmployee() {
      this.$router.push({ name: 'setting-employee-edit' });
    }
  }
};
</script>

<style scoped>
.role-title {
  font-size: 16px;
  font-weight: 500;
}
.role-item {
  color: #999;
  display: inline-block;
  margin-right: 8px;
}
</style>
